import { render } from "./ViewDeductions.vue?vue&type=template&id=01ceae92&scoped=true"
import script from "./ViewDeductions.vue?vue&type=script&lang=js"
export * from "./ViewDeductions.vue?vue&type=script&lang=js"

import "./deductions.scss?vue&type=style&index=0&id=01ceae92&lang=scss&scoped=true"
import "./ViewDeductions.vue?vue&type=style&index=1&id=01ceae92&lang=scss&scoped=true"

import exportComponent from "/srv/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ceae92"]])

export default __exports__